<template>
    <v-row dense class="table-row w-100">
        <v-col class="col-6 pl-0 name-value-label">
            {{ label }}
        </v-col>
        <v-col class="col-6 name-value-value" v-if="type">
            {{ id ? name (id, type) : '---'  }}
        </v-col>
        <v-col class="col-6 name-value-value" v-if="!type">
            {{ val }}
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "CNameValueRow",

    props: {
        label: {

        },

        property: {

        },

        data: {

        },

        type: {

        },

        area: {
            required: false,
            default: function () {
                return "msd";
            }
        }
    },

    computed: {
        id () {
            return this.data[this.property] && this.data[this.property].id;
        },

        val () {
            if (!this.data[this.property]) {
                return "---"
            }

            return this.data[this.property];
        }
    },

    methods: {
        name (id, type) {
            const area = this.$store.getters[this.area]
            const list = area[type];
            if (list) {
                const item = list.find (i => i.id === id);
                if (item) {
                    return item.name;
                }
            }

            return "---";
        }

    }
}
</script>

<style scoped>

.name-value-label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.name-value-value {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>